import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

/**
 * Retry a failed workflow run via GitHub re-run-failed-jobs (same run id,
 * attempt + 1). A failed release returns to running until every run is terminal.
 */
export const retryWorkflowRun = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/runs/:runId/retry',
  params: z.object({ releaseId: z.string().uuid(), runId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
});
